export type DeferredPromise<T = void> = {
  promise: Promise<T>;
  resolve: (value: T) => void;
  reject: (reason?: unknown) => void;
};

export const createDeferredPromise = <T = void>(): DeferredPromise<T> => {
  const deferred = {} as DeferredPromise<T>;
  deferred.promise = new Promise<T>((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
};
